import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import ProgressiveLoaderBase from './ProgressiveLoaderBase'

const TIMER_INCREMENT_DELAY = 500

class ProgressiveLoader extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      previousStepsEstimatedDurationSum:
        props.previousStepsEstimatedDurationSum || 0,
      stepElapsedDuration: 0,
    }

    this.timer = null
  }

  componentDidMount() {
    if (!this.props.stop) {
      this.startTimer()
    }
  }

  componentWillUnmount() {
    this.stopTimer()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentStep = this.props.step
    const currentStepId = currentStep.id

    const nextStep = nextProps.step
    const nextStepId = nextStep && nextStep.id

    const previousStepsEstimatedDurationSum = nextProps.previousStepsEstimatedDurationSum
      ? nextProps.previousStepsEstimatedDurationSum
      : this.state.previousStepsEstimatedDurationSum

    const stop = nextProps.stop

    if (stop) {
      this.stopTimer()
    } else {
      this.startTimer()
    }

    if (nextStepId !== currentStepId) {
      this.stopTimer()

      this.setState({
        previousStepsEstimatedDurationSum: nextStep
          ? previousStepsEstimatedDurationSum
          : 0,
        stepElapsedDuration: 0,
      })

      this.startTimer()
    }
  }

  startTimer = () => {
    if (this.timer) {
      return
    }

    this.timer = setInterval(() => {
      const { stepElapsedDuration } = this.state
      const { step } = this.props
      const stepEstimatedDuration = step && step.estimatedDuration

      if (stepElapsedDuration < stepEstimatedDuration) {
        this.setState({
          stepElapsedDuration: stepElapsedDuration + TIMER_INCREMENT_DELAY,
        })
      } else {
        this.stopTimer()
      }
    }, TIMER_INCREMENT_DELAY)
  }

  stopTimer = () => {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  render() {
    const { step, estimatedDuration, intl } = this.props

    const {
      previousStepsEstimatedDurationSum,
      stepElapsedDuration,
    } = this.state

    const stepEstimatedDuration = step.estimatedDuration
    const stepMessage =
      step &&
      step.message &&
      intl.formatMessage({
        id: step.message,
      })

    const progressPercent = calculateProgressPercent(
      stepEstimatedDuration,
      stepElapsedDuration,
      previousStepsEstimatedDurationSum,
      estimatedDuration
    )

    return (
      <div className="flex flex-column items-center justify-center">
        <div className="flex-none relative w-50 w-40-ns w-20-l">
          <ProgressiveLoaderBase
            progress={progressPercent}
            textClasses="fw3 f3 f2-ns c-muted-1"
            variation="primary"
          />
        </div>
        {stepMessage ? (
          <div
            id="ProgressiveLoaderMessage"
            className="flex-none mt6 mt7-ns f4-ns gray tc"
          >
            {stepMessage}
          </div>
        ) : null}
      </div>
    )
  }
}

function calculateProgressPercent(
  stepEstimatedDuration,
  stepElapsedDuration,
  previousStepsEstimatedDurationSum,
  estimatedDuration
) {
  const protectedStepElapsedDuration = Math.min(
    stepEstimatedDuration,
    stepElapsedDuration
  )
  const duration =
    previousStepsEstimatedDurationSum + protectedStepElapsedDuration
  const percent = duration / estimatedDuration
  const protectedPercent = Math.min(percent, 1)
  return protectedPercent
}

ProgressiveLoader.propTypes = {
  step: PropTypes.shape({
    id: PropTypes.string.isRequired,
    estimatedDuration: PropTypes.number.isRequired,
    message: PropTypes.string,
  }).isRequired,
  stop: PropTypes.bool,
  previousStepsEstimatedDurationSum: PropTypes.number,
  estimatedDuration: PropTypes.number.isRequired,
  intl: intlShape.isRequired,
}

export default injectIntl(ProgressiveLoader)
